import { PathingForm } from './../objects/pathingForm';
import { format } from 'date-fns';
import { getDefaultCurrency } from '../../../functions/getDefaultCurrency';
import { FlightSerie } from './../objects/flightSerie';
import * as locales from 'date-fns/locale';
import i18next from 'i18next';


const locales_cpy: { [key: string]: any } = locales;

export interface ManualFlightSeriesColumn {
    label: string;
    key: keyof FlightSerie;
    editable: boolean,
    numeric?: boolean,
    getValue: (flightSerie: FlightSerie) => string | number | JSX.Element ;
    getError: (flightSerie: FlightSerie) => string;
}
export const MANUAL_FLIGHT_SERIES_COLUMN: ManualFlightSeriesColumn[] = [
    {
        label: 'date',
        key: 'date',
        getValue: (flightSerie: FlightSerie) => format(new Date(flightSerie.date), 'dd/MM/yyyy', { locale: locales_cpy[i18next.language.replace("-", "")] }),
        getError: flightSerie => '',
        editable: false
    },
    {
        label: 'manual-flight.stock',
        key: 'total_stock',
        getValue: (flightSerie: FlightSerie) => flightSerie.total_stock,
        getError: flightSerie => flightSerie.total_stock_error,
        editable: true,
        numeric: true

    },
    {
        label: 'pnr-number',
        key: 'pnr_number',
        getValue: (flightSerie: FlightSerie) => flightSerie.pnr_number,
        getError: flightSerie => flightSerie.pnr_number_error,
        editable: true

    },
    {
        label: 'retrocession-type',
        key: 'retrocession_date_type',
        getValue: (flightSerie: FlightSerie) => flightSerie.retrocession_date_type,
        getError: flightSerie => '',
        editable: true

    },
    {
        label: 'retrocession',
        key: 'retrocession_date_number',
        getValue: (flightSerie: FlightSerie) => (flightSerie.retrocession_date_number ?? ''),
        getError: flightSerie => flightSerie.retrocession_date_date_error,
        editable: true,
        numeric: true

    },
    {
        label: 'purchase-price-adult-duty-free',
        key: 'purchase_price_adult',
        getValue: (flightSerie: FlightSerie) => flightSerie.purchase_price_adult,
        getError: flightSerie => flightSerie.purchase_price_adult_error,
        editable: true,
        numeric: true

    },
    {
        label: 'purchase-price-child-duty-free',
        key: 'purchase_price_child',
        getValue: (flightSerie: FlightSerie) => flightSerie.purchase_price_child,
        getError: flightSerie => flightSerie.purchase_price_child_error,
        editable: true,
        numeric: true

    },
    {
        label: 'purchase-price-infant-duty-free',
        key: 'purchase_price_infant',
        getValue: (flightSerie: FlightSerie) => flightSerie.purchase_price_infant,
        getError: flightSerie => flightSerie.purchase_price_infant_error,
        editable: true,
        numeric: true

    },
    {
        label: 'selling-price-adult-duty-free',
        key: 'price_adult',
        getValue: (flightSerie: FlightSerie) => flightSerie.price_adult,
        getError: flightSerie => flightSerie.price_adult_error,
        editable: true,
        numeric: true

    },
    {
        label: 'selling-price-child-duty-free',
        key: 'price_child',
        getValue: (flightSerie: FlightSerie) => flightSerie.price_child,
        getError: flightSerie => flightSerie.price_child_error,
        editable: true,
        numeric: true

    },
    {
        label: 'selling-price-infant-duty-free',
        key: 'price_infant',
        getValue: (flightSerie: FlightSerie) => flightSerie.price_infant,
        getError: flightSerie => flightSerie.price_infant_error,
        editable: true,
        numeric: true

    },
    {
        label: 'taxes-adult',
        key: 'taxes_adult',
        getValue: (flightSerie: FlightSerie) => flightSerie.taxes_adult,
        getError: flightSerie => flightSerie.taxes_adult_error,
        editable: true,
        numeric: true

    },
    {
        label: 'taxes-child',
        key: 'taxes_child',
        getValue: (flightSerie: FlightSerie) => flightSerie.taxes_child,
        getError: flightSerie => flightSerie.taxes_child_error,
        editable: true,
        numeric: true

    },
    {
        label: 'taxes-infant',
        key: 'taxes_infant',
        getValue: (flightSerie: FlightSerie) => flightSerie.taxes_infant,
        getError: flightSerie => flightSerie.taxes_infant_error,
        editable: true,
        numeric: true

    },

];

export const DEFAULT_CURRENCY = getDefaultCurrency();

export const EMPTY_PATHING_FORM: PathingForm = {
    airline: null,
    airline_error: '',
    currency: getDefaultCurrency(),
    currency_error: '',
    total_stock: 0,
    total_stock_error: '',
    pnr_number: '',
    pnr_number_error: '',
    price_adult: 0,
    price_adult_error: '',
    price_child: 0,
    price_child_error: '',
    price_infant: 0,
    price_infant_error: '',
    purchase_price_adult: 0,
    purchase_price_adult_error: '',
    purchase_price_child: 0,
    purchase_price_child_error: '',
    purchase_price_infant: 0,
    purchase_price_infant_error: '',
    segments_outbound: [],
    segments_outbound_control: [],
    segments_return: [],
    segments_return_control: [],
    taxes_adult: 0,
    taxes_adult_error: '',
    taxes_child: 0,
    taxes_child_error: '',
    taxes_infant: 0,
    taxes_infant_error: '',
};
